import { TFunction } from 'react-i18next';

const safeT = (t: TFunction, key?: string, defaultValue?: string, fallback = '') => {
  if (!key) return fallback;
  const translationValue = t(key, defaultValue);
  return translationValue || defaultValue || fallback;
};

export default safeT;
